<template>
    <div class="NewVolunteerFamily container-fluid">

        <!--CREATE NEW TRANSACTION-->
        <b-modal ref="modal-component" size="lg" title="Add New Volunteer Family" hide-footer>
            <b-container>
                <b-form @submit="SaveRecord">
                    <b-row>
                        <b-col>
                            <h4>General Info</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Family Name:</label>
                                <input v-model="TargetRecord.Name" required class="form-control" />
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Territory:</label>
                                <select v-model="TargetRecord.SubProgramTerritoryID" required class="form-control">
                                    <option v-for="option in SubProgramTerritoryOptions" :value="option.value">{{option.text}}</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>Address</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Physical Address:</label>
                                <input type="text" v-model="TargetRecord.PhysicalAddressLine1" class="form-control" placeholder="Address Line 1" />
                                <input type="text" v-model="TargetRecord.PhysicalAddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                                <b-row>
                                    <div class="col-5 no-padding">
                                        <input type="text" v-model="TargetRecord.PhysicalCity" class="form-control" placeholder="City" />
                                    </div>
                                    <div class="col-3 no-padding">
                                        <select class="form-control" v-model="TargetRecord.PhysicalStateAbbreviation" required>
                                            <option v-for="option in StateOptions" :value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-4 no-padding">
                                        <input type="text" v-model="TargetRecord.PhysicalZipCode" class="form-control" placeholder="Zip" />
                                    </div>
                                </b-row>
                                <div class="form-group">
                                    <label>County:</label>
                                    <v-select :options="CountyOptions" label="text" :reduce="option => option.value" v-model="TargetRecord.County"></v-select>
                                </div>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Mailing Address: <font-awesome-icon :icon="['fa', 'robot']" @click="CopyPhysicalAddress()" class="pointer" /></label>
                                <input type="text" v-model="TargetRecord.MailingAddressLine1" class="form-control" placeholder="Address Line 1" />
                                <input type="text" v-model="TargetRecord.MailingAddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                                <b-row>
                                    <div class="col-5 no-padding">
                                        <input type="text" v-model="TargetRecord.MailingCity" class="form-control" placeholder="City"  />
                                    </div>
                                    <div class="col-3 no-padding">
                                        <select class="form-control" v-model="TargetRecord.MailingStateAbbreviation">
                                            <option v-for="option in StateOptions" :value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-4 no-padding">
                                        <input type="text" v-model="TargetRecord.MailingZipCode" class="form-control" placeholder="Zip" />
                                    </div>
                                </b-row>
                            </div>

                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>Contact Info</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Phone Number for Notifications:</label>
                                <input placeholder="enter full 10 digit phone number" type="text" v-model="TargetRecord.SFPhoneNumber" class="form-control" />
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Email for Notifications:</label>
                                <input type="text" v-model="TargetRecord.SFEmail" class="form-control" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>Family Status</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Current Status:</label>
                                <select v-model="TargetRecord.MainStatus" class="form-control" required>
                                    <option value=""></option>
                                    <option v-for="approvalStatus in ApprovalStatuses" :value="approvalStatus.value">{{approvalStatus.text}}</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>Family Type</h4>
                            <div class="form-group">
                                <label>Host Family:</label>
                                <select v-model="TargetRecord.IsHost" class="form-control" required>
                                    <option value=""></option>
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Family Friend:</label>
                                <select v-model="TargetRecord.IsFriend" class="form-control" required>
                                    <option value=""></option>
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Champion:</label>
                                <select v-model="TargetRecord.IsChampion" class="form-control" required>
                                    <option value=""></option>
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <h4>Contact Preferences</h4>
                            <div class="form-group">
                                <label>Text Preference:</label>
                                <select v-model="TargetRecord.IsTextMessageOK" class="form-control" required>
                                    <option value=""></option>
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Email Preference:</label>
                                <select v-model="TargetRecord.IsEmailMessageOK" class="form-control" required>
                                    <option value=""></option>
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Mail Preference:</label>
                                <select v-model="TargetRecord.IsMailOK" class="form-control" required>
                                    <option value=""></option>
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>Relationship</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Olive Crest Relationship Started:</label>
                                <flat-pickr v-model="TargetRecord.StartDate" class="form-control" :config="DateConfig" required></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Source of Relationship:</label>
                                <input type="text" class="form-control" v-model="TargetRecord.StatusComments" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="HideModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';


    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faChurch } from '@fortawesome/free-solid-svg-icons';
    library.add(faChurch);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);

    
    export default {
        name: "NewVolunteerFamily",
        created() {
 
        },
        props: [],
        data: function () {
            return {
                //AUX
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
                TargetRecord: {},
                ApprovalStatuses: [
                    {
                        text: "Approved",
                        value: "Approved"
                    },
                    {
                        text: "Coordinator",
                        value: "Coordinator"
                    },
                    {
                        text: "In Training",
                        value: "In Training"
                    },
                    {
                        text: "No App Form",
                        value: "No App Form"
                    },
                    {
                        text: "No Roles",
                        value: "No Roles"
                    },
                    {
                        text: "On Hold",
                        value: "On Hold"
                    },
                    {
                        text: "RF Exclusive",
                        value: "RF Exclusive"
                    },
                    {
                        text: "Switched Off",
                        value: "Switched Off"
                    }
                ],
            };
        },
        methods: {
            //API
            SaveRecord(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "StrongFamilies/VolunteerFamilies", this.TargetRecord, this.SaveRecordSuccess, () => { }, true);
            },
            SaveRecordSuccess(response) {
                this.$emit("updatetable");
                this.HideModal();
            },
            //UI
            ShowModal() {
                this.TargetRecord = {

                };
                this.$refs['modal-component'].show();
            },
            HideModal() {
                this.$refs['modal-component'].hide();
            },
            CopyPhysicalAddress() {
                this.TargetRecord.MailingAddressLine1 = this.TargetRecord.PhysicalAddressLine1;
                this.TargetRecord.MailingAddressLine2 = this.TargetRecord.PhysicalAddressLine2;
                this.TargetRecord.MailingCity = this.TargetRecord.PhysicalCity;
                this.TargetRecord.MailingStateAbbreviation = this.TargetRecord.PhysicalStateAbbreviation
                this.TargetRecord.MailingZipCode = this.TargetRecord.PhysicalZipCode;
                this.$forceUpdate();
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            vSelect
        },
        computed: {
            StateOptions: function () {
                return [
                    {
                        text: "California",
                        value: "CA"
                    },
                    {
                        text: "Nevada",
                        value: "NV"
                    },
                    {
                        text: "Washington",
                        value: "WA"
                    }
                ];
                
            },
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            },
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            },
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>